import { MiniRouter } from '@yimoka/mini-router';
import { observer } from '@yimoka/react';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { useEffect } from 'react';

import { InitConfig } from '@/config';
import { LoadAppConfig } from '@/load-app-config';
import { I18nRoot } from '@/locales/i18n';
import { useLanguage } from '@/root';
import { RootRouter } from '@/router';

dayjs.locale('zh-cn');
dayjs.extend(duration);
dayjs.extend(isoWeek);
dayjs.extend(weekOfYear);

const isEn = (lang: string) => lang?.includes('en');

export const App = observer(() => {
  const lang = useLanguage();
  useEffect(() => {
    if (isEn(lang)) {
      dayjs.locale('en');
    } else {
      dayjs.locale('zh-cn');
    }
  }, [lang]);

  return (
    <MiniRouter>
      <LoadAppConfig>
        <InitConfig>
          <I18nRoot>
            <RootRouter />
          </I18nRoot>
        </InitConfig>
      </LoadAppConfig>
    </MiniRouter>
  );
});
